import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BellRing } from "lucide-react";
import { api } from "@/lib/api";
import VerifyItem from "@/components/invoices/VerifyItem";

export const VERIFY_EVENT = "oresto:verify-changed";

export default function VerifyBox() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const [items, setItems] = useState(null);
  const [all, setAll] = useState(false);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/invoices/to-verify"); setItems(data.items); } catch { setItems([]); }
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (items && new URLSearchParams(search).get("verifier")) ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [items, search]);

  const done = () => { load(); window.dispatchEvent(new Event(VERIFY_EVENT)); };
  if (!items?.length) return null;
  return (
    <section ref={ref} id="factures-a-verifier" className="card-c border-2 border-[#F5C87A] bg-[#FFF8EB] space-y-3 scroll-mt-4" data-testid="verify-box">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-secondary-c text-white flex items-center justify-center shrink-0"><BellRing className="w-4 h-4" /></div>
        <div className="min-w-0">
          <h3 className="font-display text-xl">{t("verify.title")} <span className="text-secondary-c" data-testid="verify-box-count">({items.length})</span></h3>
          <p className="text-xs text-text-secondary">{t("verify.subtitle")}</p>
        </div>
      </div>
      <ul className="space-y-2">{(all ? items : items.slice(0, 5)).map((inv) => <VerifyItem key={inv.id} inv={inv} onDone={done} />)}</ul>
      {items.length > 5 && (
        <button type="button" onClick={() => setAll(!all)} className="w-full h-10 rounded-xl border border-c bg-white text-sm font-semibold" data-testid="verify-box-toggle-all">
          {all ? t("verify.show_less") : t("verify.show_all", { count: items.length })}
        </button>
      )}
    </section>
  );
}
